import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDocumentData } from "react-firebase-hooks/firestore";
import {
  FieldValue,
  firestore,
} from "../../../components/firebase/FirebaseProvider";
import useStyles from "./style";
import { useData } from "../../../components/firebase/DataProvider";
import { useDebounce } from "use-debounce";
import currency, {
  calculateHargaLevel,
  calculatePromoLevel,
} from "../../../utils/currency";
import { findOnePromo } from "../../../utils/promo";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Typography from "@material-ui/core/Typography";
import { Divider, useMediaQuery, useTheme } from "@material-ui/core";

function Item({
  alamatId,
  variantId,
  variant,
  products,
  callSetInvalidJumlah,
  invalidJumlah,
  index,
  setProducts,
  check,
}) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("340"));
  const classes = useStyles();
  const { level, cartRef, promo, global_komisi, preorderUtils } = useData();
  const realVariantId = useRef((variantId?.split?.("_") ?? []).pop()).current;
  const variantRef = firestore.doc(
    `products/${variant?.product}/variants/${realVariantId}`
  );
  const productRef = firestore.doc(`products/${variant?.product}`);
  const [data, loading] = useDocumentData(variantRef, { idField: "id" });
  const [product, loadingProd] = useDocumentData(productRef, {
    idField: "id",
  });
  const promoFound = findOnePromo(product, promo);
  const [jumlah, setJumlah] = useState(variant?.jumlah);
  const [debounceJumlah] = useDebounce(jumlah, 750);

  const produkValue =
    product?.product_value !== undefined &&
    product?.product_value !== "" &&
    !Number.isNaN(product?.product_value) &&
    product?.product_value >= 0
      ? product?.product_value
      : 1;

  const productProperties = product?.properties;

  let textInvalidStyle = "";
  let checkJumlah =
    Object.values(invalidJumlah?.[data?.sku]?.total ?? {}).reduce(
      (n1, n2) => n1 + n2,
      0
    ) > invalidJumlah?.[data?.sku]?.stok;
  let checkActivePreorder =
    productProperties && productProperties?.type === "preorder"
      ? productProperties?.orderable
      : true;

  let listProductType = products?.map(([_, value]) => {
    return value?.type;
  });

  listProductType = [...new Set(listProductType)];
  const checkDifferentType = listProductType.length > 1;

  // invalid style = jumlah true || orderable product true || differetn type in one alamat false
  const invalidStyle =
    checkJumlah || !checkActivePreorder || checkDifferentType
      ? classes.invalidStok
      : {};

  textInvalidStyle = checkJumlah
    ? "Sesuaikan jumlah dengan stok yang tersedia"
    : !checkActivePreorder
    ? "Preorder sudah melewati waktu kadalwarsa"
    : checkDifferentType
    ? "Preorder tidak dapat digabung dengan produk biasa"
    : "";

  const setPromoDB = async (promoRes, isType) => {
    try {
      await cartRef.set(
        {
          subcarts: {
            [alamatId]: {
              products: {
                [variantId]: {
                  promo: promoRes,
                  type: isType,
                },
              },
            },
          },
        },
        { merge: true }
      );
    } catch (error) {
      console.log("Error find promo : ", error);
    }
  };

  useEffect(() => {
    if (!variant?.jumlah || !variant?.nama || !variant?.product) {
      handleDeleteItem();
    }
  }, [variant?.jumlah, variant?.nama, variant?.product]);

  useEffect(() => {
    if (product && !loadingProd) {
      (async () => {
        const isType = product?.properties?.type
          ? product?.properties?.type
          : "normal";
        if (promoFound) {
          setPromoDB(promoFound.id, isType);
        } else {
          setPromoDB("", isType);
        }
      })();
    }
  }, [product, loadingProd, promo, promoFound]);

  useEffect(() => {
    if (!loading) {
      setCartProducts(debounceJumlah);
    }
  }, [debounceJumlah, loading]);

  useEffect(() => {
    if (data?.sku) {
      callSetInvalidJumlah(
        data?.sku,
        data?.stok_available,
        alamatId,
        check === "Y" ? variant?.jumlah : 0,
        productProperties?.type,
        check === "Y" ? checkActivePreorder : true,
        check === "Y" ? checkDifferentType : false
      );
      const harga = calculatePromoLevel(
        data?.harga_normal,
        promoFound,
        level.level,
        global_komisi,
        produkValue
      );
      setProducts(data?.sku, variant?.jumlah, harga);
    }
  }, [
    alamatId,
    callSetInvalidJumlah,
    data?.sku,
    data?.stok_available,
    variant?.jumlah,
    setProducts,
    data?.harga_normal,
    data?.id,
    promoFound,
    level.level,
    global_komisi,
    check,
    productProperties?.type,
    checkActivePreorder,
    checkDifferentType,
    produkValue,
  ]);

  const setCartProducts = useCallback(
    async (jumlahBaru) => {
      try {
        const bayar = promoFound
          ? calculatePromoLevel(
              data?.harga_normal,
              promoFound,
              level.level,
              global_komisi,
              produkValue
            )
          : calculateHargaLevel(
              data?.harga_normal,
              global_komisi,
              level?.level,
              produkValue
            );

        const jumlahLama = variant?.jumlah;

        const updatedNumber = jumlahBaru - jumlahLama;

        if (updatedNumber === 0) return;

        console.log(variant?.type == "preorder")

        const isPreorder =
          variant?.type == "preorder" && preorderUtils?.down_payment_option
            ? {
                nilai_dp: FieldValue.increment(
                  Math.round(
                    (preorderUtils?.down_payment_percentage / 100) *
                      bayar *
                      updatedNumber
                  )
                ),
              }
            : "";

        await cartRef.set(
          {
            subcarts: {
              [alamatId]: {
                products: {
                  [variantId]: {
                    jumlah: jumlahBaru,
                  },
                },
                ...isPreorder,
                total_pembayaran: FieldValue.increment(bayar * updatedNumber),
                total_tagihan: FieldValue.increment(bayar * updatedNumber),
                total_tagihan_harga_normal: FieldValue.increment(
                  data?.harga_normal * updatedNumber
                ),
                berat_total: FieldValue.increment(
                  data?.berat_paket * updatedNumber
                ),
              },
            },

            updated_at: FieldValue.serverTimestamp(),
          },
          { merge: true }
        );
      } catch (error) {
        console.log("error jumlah = ", error);
      }
    },
    [
      data?.harga_normal,
      data?.berat_paket,
      promoFound,
      level.level,
      global_komisi,
      variant?.jumlah,
      produkValue,
    ]
  );

  const handleChangeJumlah = (value) => async (e) => {
    if (value === -1 && jumlah <= 1) {
      return;
    }

    if (
      (value === 1 && jumlah + 1 > data?.stok_available) ||
      (value === 1 && invalidStyle === classes.invalidStok)
    ) {
      return;
    }

    setJumlah((prevJumlah) => prevJumlah + value);
  };

  const handleDeleteItem = async (e) => {
    try {
      const bayar = promoFound
        ? calculatePromoLevel(
            data?.harga_normal,
            promoFound,
            level.level,
            global_komisi,
            produkValue
          )
        : calculateHargaLevel(
            data?.harga_normal,
            global_komisi,
            level?.level,
            produkValue
          );

      let deletedData = {
        subcarts: {
          [alamatId]: {
            products: {
              [variantId]: FieldValue.delete(),
            },
            total_pembayaran: FieldValue.increment(-(bayar * variant?.jumlah)),
            total_tagihan: FieldValue.increment(-(bayar * variant?.jumlah)),
            total_tagihan_harga_normal: FieldValue.increment(
              -(data?.harga_normal * variant?.jumlah)
            ),
            berat_total: FieldValue.increment(
              -(data?.berat_paket * variant?.jumlah)
            ),
          },
        },
        updated_at: FieldValue.serverTimestamp(),
      };
      if (products.length <= 1) {
        deletedData = {
          subcarts: {
            [alamatId]: FieldValue.delete(),
          },
          payment_type: FieldValue.delete(),
          updated_at: FieldValue.serverTimestamp(),
        };
      }
      await cartRef.set(deletedData, { merge: true });
      callSetInvalidJumlah(
        data?.sku,
        data?.stok_available,
        alamatId,
        0,
        productProperties?.type,
        check === "Y" ? checkActivePreorder : true,
        check === "Y" ? checkDifferentType : false
      );
      setProducts(data?.sku, 0, 0);
    } catch (error) {
      console.log("Error Delete", error);
    }
  };

  const bayar = promoFound
    ? calculatePromoLevel(
        data?.harga_normal,
        promoFound,
        level.level,
        global_komisi,
        produkValue
      )
    : calculateHargaLevel(
        data?.harga_normal,
        global_komisi,
        level?.level,
        produkValue
      );

  return (
    <div>
      <div className={classes.headProduk}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography className={classes.liquidPrimary}>
            Pesanan {index + 1}
          </Typography>
          {product?.properties?.type === "preorder" && (
            <div className={classes.boxPre}>
              <Typography color="primary" className={classes.liquidPre}>
                Preorder
              </Typography>
            </div>
          )}
        </div>
        <div style={{ cursor: "pointer" }} onClick={handleDeleteItem}>
          <Typography color="secondary" className={classes.liquidPrimary}>
            Hapus
          </Typography>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          padding: "5px",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              style={{
                width: 75,
                height: 75,
                marginRight: "10px",
                borderRadius: 4,
              }}
              src={data?.thumbnail?.[0]}
              alt="logo"
            />
          </div>
          <div style={{ marginLeft: "1.5%" }}>
            <div style={{ display: "flex" }}>
              <div style={{ display: "inline-grid" }}>
                <Typography
                  style={{
                    fontSize: 12,
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  {variant?.nama}
                </Typography>
              </div>
            </div>
            <div>
              <Typography
                className={classes.liquidSmallGrey}
                style={{ marginBottom: "3px", marginTop: "3px" }}
              >
                Variasi: {data?.variant2?.nilai}, {data?.variant1?.nilai}
              </Typography>
            </div>
            <div style={matches ? { display: "flex" } : {}}>
              {promoFound && (
                <Typography
                  noWrap
                  className={classes.liquidSmallGrey}
                  style={{ marginRight: "10px" }}
                >
                  {currency(bayar)} / item
                </Typography>
              )}
              <Typography
                noWrap
                style={
                  promoFound && {
                    textDecoration: "line-through",
                  }
                }
                className={classes.liquidSmallGrey}
              >
                {currency(
                  calculateHargaLevel(
                    data?.harga_normal,
                    global_komisi,
                    level?.level,
                    produkValue
                  )
                )}{" "}
                / item
              </Typography>
            </div>
            <Typography
              noWrap
              className={classes.liquidSmallBold}
              style={{ marginRight: "10px" }}
            >
              {currency(bayar * jumlah)}
            </Typography>
            {invalidStyle === classes.invalidStok ? (
              <Typography className={classes.liquidRed}>
                {textInvalidStyle}
              </Typography>
            ) : null}
          </div>
        </div>
        <div className={classes.btnCounter}>
          <IconButton
            size="small"
            disableRipple
            className={classes.decrement}
            onClick={handleChangeJumlah(-1)}
          >
            <RemoveIcon style={{ fontSize: "17.5px" }} />
          </IconButton>
          <div className={classes.displayCounter}>{jumlah}</div>
          <IconButton
            size="small"
            disableRipple
            className={classes.increment}
            onClick={handleChangeJumlah(1)}
          >
            <AddIcon style={{ fontSize: "17.5px" }} />
          </IconButton>
        </div>
      </div>
      {invalidStyle === classes.invalidStok ? (
        <Divider style={{ backgroundColor: "red" }} />
      ) : null}
    </div>
  );
}

export default Item;
